const DEFAULT_CUTOFF_HOURS = 12;

// `hide` (display: none) rather than `hidden` (visually hidden): once registration has
// closed the form or embedded Microsoft Form must leave the accessibility tree too, not
// just the screen. The closed notice is revealed in its place.
const hideFormSection = (content) => {
    const eoiForm = content.querySelector('.single-event__eoi');
    const cta = content.querySelector('.single-event__cta');

    if (eoiForm) {
        eoiForm.classList.add('hide');
    }

    if (cta) {
        cta.classList.add('hide');
    }
};

const hideTicketSection = (content) => {
    const headings = content.querySelectorAll('h3');

    headings.forEach((heading) => {
        const text = heading.textContent.trim();

        if (text === 'Ticket Information' || text === 'All Dates') {
            let sibling = heading.nextElementSibling;

            heading.classList.add('hide');
            while (
                sibling &&
                sibling.tagName !== 'HR' &&
                sibling.tagName !== 'H2'
            ) {
                sibling.classList.add('hide');
                sibling = sibling.nextElementSibling;
            }
            if (sibling && sibling.tagName === 'HR') {
                sibling.classList.add('hide');
            }
        }
    });

    const links = content.querySelectorAll('a');

    links.forEach((link) => {
        if (link.textContent.trim().includes('Get Tickets')) {
            const parent = link.closest('p');

            if (parent) {
                parent.classList.add('hide');
            }
        }
    });
};

const closeSingleEvent = (el) => {
    const eventContent = el.closest('.single-event');

    if (eventContent) {
        hideFormSection(eventContent);
        hideTicketSection(eventContent);
    }

    const notice = el.querySelector('.single-event__notice--closed');

    if (notice) {
        notice.classList.remove('hidden');
    }
};

const closeListingCard = (el) => {
    const action =
        el.querySelector('.block__action') ||
        el.querySelector('.events__action');
    const blockContent =
        el.querySelector('.block__text') || el.querySelector('.events__meta');

    if (action) {
        const icon = action.querySelector('[data-grunticon-embed]');

        action.textContent = 'view details';

        if (icon) {
            action.appendChild(icon);
        }
    }

    const tag = document.createElement('div');

    tag.className = 'single-event__tag--closed';
    tag.textContent = 'Registration closed';

    if (blockContent) {
        blockContent.prepend(tag);
    }
};

const applyClosedState = (el) => {
    // The script can be enqueued under several handles on one page (AssetLoader maps it
    // per module), so guard against closing the same element twice.
    if (el.dataset.cutoffApplied) {
        return;
    }

    el.dataset.cutoffApplied = '1';

    if (el.classList.contains('h-event')) {
        closeSingleEvent(el);
    } else {
        closeListingCard(el);
    }
};

const checkElement = (el) => {
    const startStr = el.getAttribute('data-event-start');

    if (!startStr) {
        return;
    }

    const eventStart = new Date(startStr);

    if (isNaN(eventStart.getTime())) {
        return;
    }

    const cutoffHours =
        el.getAttribute('data-event-cutoff') !== null
            ? parseFloat(el.getAttribute('data-event-cutoff'))
            : DEFAULT_CUTOFF_HOURS;

    // data-event-start is an ISO string with its UTC offset, so it is already an absolute
    // instant; comparing against Date.now() is correct in every visitor's timezone.
    const cutoffTime = eventStart.getTime() - cutoffHours * 60 * 60 * 1000;

    if (Date.now() >= cutoffTime) {
        applyClosedState(el);
    }
};

const init = () => {
    const elements = document.querySelectorAll('[data-event-start]');

    if (!elements.length) {
        return;
    }

    elements.forEach((el) => checkElement(el));
};

export default { init };
